import { render, staticRenderFns } from "./FlexGerenciaSaldoManage.vue?vue&type=template&id=649361d6&scoped=true"
import script from "./FlexGerenciaSaldoManage.vue?vue&type=script&lang=js"
export * from "./FlexGerenciaSaldoManage.vue?vue&type=script&lang=js"
import style0 from "./FlexGerenciaSaldoManage.vue?vue&type=style&index=0&id=649361d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649361d6",
  null
  
)

export default component.exports